module.exports = __webpack_public_path__ + "static/media/sb-success.cfad66d6.svg";